module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "div1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("发货通知单")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "headerContent"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "24%"
    }
  }, [_vm._v("ADD:" + _vm._s(_vm.PageHeader.Address))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "24%"
    }
  }, [_vm._v("开单日期：" + _vm._s(_vm.PageHeader.Date))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25.3%"
    }
  }, [_vm._v("销售下单号：" + _vm._s(_vm.PageHeader.OrderCode))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25.3%",
      "text-align": "right"
    }
  }, [_vm._v("发货通知单号：" + _vm._s(_vm.PageHeader.Code))])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "1px solid white",
      "width": "10%"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("购货单位")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.PageBody.AgentCompanyName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("联系人")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.PageBody.ContactName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合同地址")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PageBody.DefaultAgentAddress))]), _vm._v(" "), _c('td', [_vm._v("手机")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PageBody.ContactTel))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "1px solid white"
    }
  }, [_vm._v("发货地址")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "1px solid white"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.PageBody.AgentAddress))])])]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.PageBody.ListProduct), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ProCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ProName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ProNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Remark))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v("寄送方式：" + _vm._s(_vm.PageBody.SendModeName) + " " + _vm._s(_vm.PageBody.PayModeName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.PageBody.Remark))])])], 2), _vm._v(" "), _c('tfoot')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "FootContent"
    }
  }, [_c('span', [_vm._v("仓库管理员：" + _vm._s(_vm.PageFooter.StockOutAdmin))]), _vm._v(" "), _c('span', [_vm._v("业务员：" + _vm._s(_vm.PageFooter.SaleEmpName))]), _vm._v(" "), _c('span', [_vm._v("开单人：" + _vm._s(_vm.PageFooter.AddUserName))]), _vm._v(" "), _c('span', [_vm._v("用户签名：")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "auto"
    }
  }, [_vm._v("发货单位：" + _vm._s(_vm.PageFooter.CompanyName))])]), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin": "20px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.printPage
    }
  }, [_vm._v("打印")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "auto",
      "margin-bottom": "-40px",
      "margin-top": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": require("../../assets/iqeq.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%",
      "height": "40px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("产品编号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%",
      "overflow": "hidden"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("拼箱箱号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("拼箱数量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dd668dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendGoods/SendGoodsPage.vue
// module id = 1535
// module chunks = 1